import React from 'react';

const CircleIcon = () => (
  <svg width="8" height="8" viewBox="0 0 8 8" fill="none" stroke="#85B5BA" xmlns="http://www.w3.org/2000/svg">
    <circle cx="4" cy="4" r="3.5" />
  </svg>
)

export default CircleIcon
